import React from 'react';

const ActiveDot = (props) => {
  const { cx, cy, fill } = props;

  return (
    <g>
      <circle cx={cx} cy={cy} r={5} fill='#fff' stroke={`${fill}60`} strokeWidth={2} />
      <circle cx={cx} cy={cy} r={3} fill={fill} />
    </g>
  );
};

export default ActiveDot;
